import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { StartupsContextProvider } from './context/startupContext';
import { AuthContextProvider } from './context/authContext';
import { UsersContextProvider } from './context/usersContext';
import { InvestorsContextProvider } from './context/investorContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthContextProvider>
      <UsersContextProvider>
        <StartupsContextProvider>
          <InvestorsContextProvider>
            <App />
          </InvestorsContextProvider>
        </StartupsContextProvider>
      </UsersContextProvider>
    </AuthContextProvider>
  </React.StrictMode>
);


